import type RequestOptions from 'owa-service/lib/RequestOptions';
export const fullResponseOperationOption: RequestOptions = { returnFullResponseOnSuccess: true };
